import Vue from 'vue'
import Router from 'vue-router'
import Login from '../views/public/Login'
import ForgotPassword from '../views/public/Forgot'
import ResetPassword from '../views/public/ResetPassword'
import Dashboard from '../views/private/Dashboard'
import CrewList from '../views/private/management/crew/List'
import UserList from '../views/private/management/user/List'
import UserArchived from '../views/private/management/user/Archived'
import DocumentTypeList from '../views/private/management/documentType/List'
import DocumentList from '../views/private/documents/Documents'
import ArchivedDocumentList from '../views/private/documents/Archived'
import DocumentTypeArchived from '../views/private/management/documentType/Archived'
import WorkOrderList from '../views/private/workOrder/List'
import TaskManager from '../views/private/workOrder/TaskManager'
import TaskArchived from '../views/private/workOrder/Archived'
import Calendar from '../views/private/Calendar'
import PrintableChecklist from '../views/private/workOrder/Checklist'
import store from '../store'
Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Login',
      component: Login,
      beforeEnter: redirect
    },
    {
      path: '/forgot',
      name: 'Forgot',
      component: ForgotPassword
    },
    {
      path: '/resetPassword/:token(.*)/:email',
      name: 'ResetPassword',
      component: ResetPassword
    },
    {
      path: '/dashboard',
      name: 'Dashboard',
      component: Dashboard,
      beforeEnter: authorized
    },
    {
      path: '/management/crews',
      name: 'CrewList',
      component: CrewList,
      beforeEnter: authorized
    },
    {
      path: '/management/users',
      name: 'UserList',
      component: UserList,
      beforeEnter: authorized
    },
    {
      path: '/management/users/archived',
      name: 'UserArchived',
      component: UserArchived,
      beforeEnter: authorized
    },
    {
      path: '/documents',
      name: 'DocumentList',
      component: DocumentList,
      beforeEnter: authorized
    },
    {
      path: '/documents-archived',
      name: 'ArchivedDocumentList',
      component: ArchivedDocumentList,
      beforeEnter: authorized
    },
    {
      path: '/management/document-types',
      name: 'DocumentTypeList',
      component: DocumentTypeList,
      beforeEnter: authorized
    },
    {
      path: '/management/document-types/archived',
      name: 'DocumentTypeArchived',
      component: DocumentTypeArchived,
      beforeEnter: authorized
    },
    {
      path: '/work-orders',
      name: 'WorkOrderList',
      component: WorkOrderList,
      beforeEnter: authorized
    },
    {
      path: '/work-order/task-manager',
      name: 'TaskManager',
      component: TaskManager,
      beforeEnter: authorizedSubForeman,
      props: true
    },
    {
      path: '/work-order/task-manager/checklist',
      name: 'PrintableChecklist',
      component: PrintableChecklist,
      beforeEnter: authorized
    },
    {
      path: '/work-orders/archived',
      name: 'TaskArchived',
      component: TaskArchived,
      beforeEnter: authorized
    },
    {
      path: '/calendar',
      name: 'Calendar',
      component: Calendar,
      beforeEnter: authorizedSubForeman,
      props: true
    }
  ]
})

function authorizedSubForeman (from, to, next) {
  if (store.state.auth.isLoggedIn) {
    next()
  } else {
    this.$router.push('login')
  }
}

function authorized (from, to, next) {
  if (store.state.auth.isLoggedIn) {
    if (store.state.user.role === 'Worker' ) {
      next({ path: '/calendar' })
    } else {
      next()
    }
  } else {
    this.$router.push('login')
  }
}
function redirect (from, to, next) {
  if (store.state.auth.isLoggedIn) {
    switch (store.state.user.role) {
      case 'Worker':
        next({ path: '/calendar' })
        break
      case 'Sub Foreman':
        next({ path: '/calendar' })
        break
      case 'Foreman':
        next({ path: '/work-orders' })
        break
      case 'Admin':
        next({ path: '/work-orders' })
        break
      default:
        next({ path: '/work-orders' })
        break
    }
  } else {
    next()
  }
}
